import React from 'react';
import styled from 'styled-components';
import { ISelection, IUser, IOption } from '../../../../domain/portal-domain';
import { mainTheme } from '../../../../styles/themes/main-theme';
import { DropdownSearch } from '../../../dropdown/dropdown-search';

const DropdownSearchContainer = styled.div`
    @media ${mainTheme.responsiveBreakpoints.normalAndBigScreen} {
        display: inline-block;
        width: ${mainTheme.widths.dropdownNormalAndUp};

        &:first-child {
            margin-right: ${mainTheme.containerMargins.big};
        }
    }
`;

const ScopeSelectors = styled.div`
    padding-bottom: ${mainTheme.containerMargins.small};
`;

interface ISelectionDropdown {
    user: IUser;
    currentSelection: ISelection;
    companyOptions: IOption[];
    installationOptions: IOption[];
    onSelectionHandler: (option: IOption) => void;
}

export const SelectionDropdown: React.FC<ISelectionDropdown> = ({
    currentSelection,
    user,
    companyOptions,
    installationOptions,
    onSelectionHandler,
}) => {
    const handleSelectionChange = (option: IOption, scope: string) => {
        if (scope === 'company') {
            if (currentSelection.installation && option.key !== currentSelection.installation.key) {
                onSelectionHandler({ key: '', value: '', id: null, type: null });
            }
        }
        onSelectionHandler(option);
    };
    return (
        <ScopeSelectors>
            <DropdownSearchContainer>
                <DropdownSearch
                    scope="company"
                    label="Select company"
                    user={user}
                    selectedOption={currentSelection.company}
                    onSelectionHandler={(option) => handleSelectionChange(option, 'company')}
                    options={companyOptions}
                />
            </DropdownSearchContainer>
            <DropdownSearchContainer>
                <DropdownSearch
                    scope="installation"
                    label="Select installation"
                    user={user}
                    selectedOption={currentSelection.installation}
                    onSelectionHandler={(option) => handleSelectionChange(option, 'installation')}
                    options={installationOptions}
                />
            </DropdownSearchContainer>
        </ScopeSelectors>
    );
};
